import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { LocationAutocomplete } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

function LocationEdit(props) {
  const { updateTable, setUpdateTable, location } = props;
  const [openEditDialog, setOpenEditDialog] = useState(false);

  const [locationName, setLocationName] = useState(location.tagName);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    // Set the fields back to the location's data
    setLocationName(location.tagName);
  }, [location, openEditDialog]);

  const handleEditLocation = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("tagId", location.tagId);
    body.append("locationName", locationName);
    axios.post("/faculty/editLocation", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenEditDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setLocationName("");
  };

  function showEditDialog() {
    return (
      <Dialog open={openEditDialog} maxWidth={false}>
        <DialogTitle className="LocationEdit-title mx-auto text-2xl font-bold font-brand-primary mt-4">
          Edit Location
        </DialogTitle>
        <div className="LocationEdit-modalContainer flex flex-col w-fit mb-4">
          <div className="LocationEdit-locationContainer flex flex-col w-96 mx-auto mb-2">
            <div className="JobEdit-locationTitle text-lg font-brand-primary">
              Location *
              </div>
              <LocationAutocomplete
                idAndClassName="JobEdit-LocationSearch"
                locationValue={locationName}
                setLocationValue={setLocationName}
                key={200}
              />
          </div>
          <div className="LocationEdit-buttonContainer flex justify-between px-12 mt-4">
            <button
              type="button"
              className="primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleEditLocation}
            >
              Update Location
            </button>

            <button
              type="button"
              className="primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => setOpenEditDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="LocationEdit-container">
      {showEditDialog()}
      <button className="flex mr-4" onClick={() => setOpenEditDialog(true)}>
        <EditIcon fontSize="large" className="fill-brand-quaternary" />
      </button>
    </div>
  );
}

LocationEdit.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  location: PropTypes.shape({
    tagId: PropTypes.number,
    tagName: PropTypes.number,
  }),
};

LocationEdit.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
  location: {},
};

export default LocationEdit;
